import { TextEllipsisStaticLine } from '../../../../../common/textEllipsis/TextEllipsisStaticLine'

export const CustomXAxisTick = ({
  x,
  y,
  payload,
  width,
  height,
  visibleTicksCount,
  titleDefaultIndustry,
  isCompare,
  isDynamicReport,
}) => {
  const { value, offset } = payload

  const tickWidth = isCompare
    ? isDynamicReport
      ? width / visibleTicksCount - 40
      : width / visibleTicksCount + 4
    : width
  const centerX = x + width / visibleTicksCount / 2 - offset
  const posX = isCompare
    ? isDynamicReport
      ? centerX - tickWidth / 2 - 10
      : centerX - tickWidth / 2
    : x - offset + width / visibleTicksCount - tickWidth / 2

  const pathX = Math.floor(x - offset + width / visibleTicksCount) + 0.5

  return (
    <g>
      <foreignObject
        x={posX || 0}
        y={y + 2}
        width={tickWidth}
        height={height || 40}
        style={{ overflow: 'visible' }}
      >
        <div
          style={{
            textAlign: 'center',
            color: '#9C9C9C',
            fontWeight: 600,
          }}
        >
          <TextEllipsisStaticLine text={value} isI18n={false} lineClamp={1} />
        </div>
      </foreignObject>

      {value === titleDefaultIndustry && isCompare ? (
        <path
          d={`M${pathX},${y + 20}v${-55}`}
          stroke="#9C9C9C"
          strokeWidth={1}
        />
      ) : null}
    </g>
  )
}
